/**
 * screens/Settings/components/SettingsRow
 * A `12–13px 15px` row inside a Settings card, divided by the light #F2F2F2
 * rule. Most Settings cards are lists of these.
 */
import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { neutral } from '../../../theme/colors';

export interface SettingsRowProps {
  children: ReactNode;
  /** The 13px padding used by the option-list and rules rows. */
  roomy?: boolean;
  /** Off for the last row in a card that has no footer. */
  divided?: boolean;
}

export function SettingsRow({ children, roomy = false, divided = true }: SettingsRowProps) {
  return (
    <View
      style={[
        styles.row,
        { paddingVertical: roomy ? 13 : 12, borderBottomWidth: divided ? 1 : 0 },
      ]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  row: { paddingHorizontal: 15, borderBottomColor: neutral.ruleLight },
});

export default SettingsRow;
